import React, { useState, useEffect } from "react";
import { Box, Grid, TextField, ButtonGroup, Button } from "@mui/material";
import Swal from "sweetalert2";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { styled } from "@mui/system";
import {
  CommonSubHeader,
  useLocationHelpers,
} from "../../Components/helpers/Helpers";
import api from "../../api/axios";
import { useNavigate } from "react-router-dom";

const Crear = () => {
  const navigate = useNavigate();

  const { goPanel, goTable } = useLocationHelpers();

  const [groupData, setGroupData] = useState({
    grupo: "", // Configura un valor inicial vacío para "grupo"
  });

  const handleGroupsFormInformation = async () => {
    const isValid = validateFields();
    if (isValid) {
      const formData = new FormData();
      formData.append("grupo", groupData.grupo);
      // Object.entries(groupData).forEach(([key, value]) => {
      //   formData.append(key, value.grupo || value); // Appends the id if it exists
      // });

      const queryUrl = `${process.env.REACT_APP_API_URL}/groups/store`;

      Swal.fire({
        title: "¿Desea guardar los cambios?",
        showDenyButton: true,
        confirmButtonColor: "#1ab394",
        cancelButtonColor: "#d33",
        reverseButtons: true,
        confirmButtonText: "Guardar",
        denyButtonText: `Volver`,
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const response = await api.post(queryUrl, formData);

            console.log(response);
            if (response.data.error) {
              Swal.fire({
                title: "¡No se guardaron los cambios!",
                icon: "error",
                text: "Por favor intentelo nuevamente",
                confirmButtonColor: "#1ab394",
              });
            } else {
              Swal.fire({
                title: "¡Guardado!",
                icon: "success",
                html: `¿Seguir creando?`,
                showDenyButton: true,
                confirmButtonColor: "#1ab394",
                cancelButtonColor: "#d33",
                reverseButtons: true,
              }).then((result) => {
                if (result.isDenied) {
                  navigate("/grupos");
                }
              });
            }
          } catch (error) {
            console.error(error);
          }
        } else if (result.isDenied) {
          Swal.fire("¡Los cambios no han sido guardados!", "", "info");
        }
      });
    } else {
      showValidationErrors();
    }
  };

  // Validate required fields
  const validateFields = () => {
    const fields = Object.entries(groupData).map(([key, value]) => ({
      value,
      name: key,
    }));
    return fields.every((field) => field.value !== "" && field.value !== null);
  };

  const showValidationErrors = () => {
    const missingFields = Object.entries(groupData)
      .filter(([, value]) => value === "" || value === null)
      .map(([key]) => `<li>${key}</li>`)
      .join("");

    Swal.fire({
      title: "¡Error!",
      icon: "error",
      html: `<div style="text-align: start;">Por favor rellene los campos: <ul>${missingFields}</ul></div>`,
      confirmButtonColor: "#1ab394",
    });
  };

  const handleChange = (event) => {
    setGroupData({
      ...groupData,
      [event.target.name]: event.target.value.trim(),
    });
  };

  // Fields for the form
  const formFields = [
    {
      name: "grupo",
      label: "Nombre",
      key: "grupo",
      type: "text",
    },
  ];

  return (
    <div className="fatherContainer">
      <CommonSubHeader title="Grupos" subTitle="Crear" />
      <Box
        component="form"
        sx={{ margin: "auto", "& > :not(style)": {} }}
        noValidate
        autoComplete="off"
        className="formMainContainer">
        <Grid
          container
          style={{ textAlign: "center" }}
          p={2}
          className="fontSize">
          {formFields.map((field, idx) =>
            field.type === "text" ? ( // Cambié "autocomplete" a "textarea" en esta línea para corregir la condición duplicada
              <Grid item xs={12} sm={12} key={idx} sx={{ padding: "5px" }}>
                <TextField
                  name={field.name}
                  label={field.label}
                  value={groupData[field.name]}
                  onChange={handleChange}
                  autoComplete="new-password" // Desactiva el autofill general
                  fullWidth
                  inputProps={{
                    maxLength:
                      field.name === "groupPostalCode" ? 10 : undefined,
                  }}
                />
              </Grid>
            ) : null,
          )}
          <Grid item xs={12}>
            <ButtonGroup
              sx={{
                width: "100%",
                justifyContent: "center",
                textAlign: "center",
                margin: "20px 5px 0px 5px",
              }}>
              <Button
                sx={{ width: "100%" }}
                onClick={handleGroupsFormInformation}
                variant="outlined"
                color="success">
                Guardar
              </Button>
              <Button
                sx={{ width: "100%" }}
                onClick={() => goTable("grupos", "Grupos")}
                variant="outlined"
                color="error">
                Tabla
              </Button>
              <Button
                sx={{ width: "100%" }}
                onClick={goPanel}
                variant="outlined">
                Inicio
              </Button>
            </ButtonGroup>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
};

export default Crear;
